import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { formatDateStr } from '../../config_and_helpers/helpers';

/**
 * HTML preview grid for stock-item QR labels (browser print fallback).
 */
const LabelPreviewGrid = ({ labels = [] }) => {
  if (!labels.length) return null;

  return (
    <>
      <p className="print-labels-modal__hint text-muted small mb-3">
        Use the links below to preview the public scan page without printing a QR code.
      </p>
      <div className="print-labels-grid">
        {labels.map(label => (
          <div key={label.stock_item_id} className="print-labels-grid__cell">
            <div className="print-labels-grid__qr">
              <QRCodeSVG value={label.scan_url} size={80} level="M" />
            </div>
            <div className="print-labels-grid__text">
              <div className="print-labels-grid__name">{label.product_name}</div>
              <div className="print-labels-grid__meta">Cat #{label.cat_num}</div>
              {label.batch ? (
                <div className="print-labels-grid__meta">Batch: {label.batch}</div>
              ) : null}
              {label.expiry ? (
                <div className="print-labels-grid__meta">
                  Exp: {formatDateStr(label.expiry)}
                </div>
              ) : null}
              {label.already_open ? (
                <div className="print-labels-grid__opened">Already opened</div>
              ) : null}
              {label.scan_url ? (
                <a
                  href={label.scan_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="print-labels-grid__link"
                >
                  Open scan page
                </a>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      <div className="print-labels-modal__url-list mt-4">
        <div className="small fw-semibold mb-2">Raw scan URLs (copy for testing)</div>
        <ul className="print-labels-modal__url-items list-unstyled mb-0">
          {labels.map(label => (
            <li key={`url-${label.stock_item_id}`} className="print-labels-modal__url-item">
              <span className="print-labels-modal__url-label">
                #{label.stock_item_id} {label.product_name}
              </span>
              <a
                href={label.scan_url}
                target="_blank"
                rel="noopener noreferrer"
                className="print-labels-modal__url-link"
              >
                {label.scan_url}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default LabelPreviewGrid;
